/*
  定数クラス
*/

const CHAR_NULL = 'null';

/* 編集状態 */
// 入力前
const EDIT_STATUS_BEFORE_INPUT = '0';
// 入力中
const EDIT_STATUS_INPUT = '1';
// 確定済み
const EDIT_STATUS_CONFIRM = '2';
// 申込済み
const EDIT_STATUS_REQUEST = '3';
/** 役員入力タイプ */
const INPUT_TYP_APPOINT = "1";
const INPUT_TYP_RESIGN = "2";
const INPUT_TYP_ADDRESS = "3";
/** 役員変更区分 */
// その他
const CHANGE_OFFICER_KBN_OTHERS = '40';
/** 資格 */
// 代表取締役
const OFFICER_KBN_DAIHYO = '10';
// システムID
const SYS_ID_TOUKI = "0522211001";

/* URL API */
const URL_API_PSS400G01 = '/api/v1.0/all/core/inquiries/editorials';
const URL_API_PSS400P01 = '/api/v1.0/all/core/inquiries/add';
const URL_API_MBA100G01 = '/api/v1.0/login/core';
const URL_API_MBA200P01 = '/api/v1.0/user/core/pwresethistories/request';
const URL_API_MBC100G01 = '/api/v1.0/all/core/customers/editorials';
const URL_API_MBC100P01 = '/api/v1.0/all/core/customers/add';
const URL_API_MBC110G01 = '/api/v1.0/user/core/customers/:customerId';
const URL_API_MBC110P01 = '/api/v1.0/user/core/customers/:customerId';
const URL_API_MBC120G01 = '/api/v1.0/user/core/webcontents/unsubscribe';
const URL_API_MBC120P01 = '/api/v1.0/user/core/customers/:customerId/unsubscribe';
const URL_API_MBC200P01 = '/api/v1.0/user/core/customers/:customerId/pw';
const URL_API_MBC210P01 = '/api/v1.0/user/core/pwresethistories/:onetimeurl';

const URL_API_MBR100G01 = '/api/v1.0/user/core/customers/:customerId/information';
const URL_API_MBR400G01 = '/api/v1.0/user/core/requests/editorials';
const URL_API_MBR500G01 = '/api/v1.0/user/core/customers/:customerId/requestdetail/:requestNo';
const URL_API_MBR500G02 = '/api/v1.0/user/core/fileinformation/:fileId';
const URL_API_MBR500P01 = '/api/v1.0/user/core/:requestNo/fileinformation/:fileId';
const URL_API_MBR500P02 = '/api/v1.0/user/core/:requestNo/fileinformation/:fileId/delete';
const URL_API_MBR500P03 = '/api/v1.0/user/core/customers/requestdetail/latestprogressclass/update';
const URL_API_MBR510P01 = '/api/v1.0/user/core/customers/:customerId/requests/add';
const URL_API_MBR510P02 = '/api/v1.0/user/core/fileinformation/:requestNo/add';

const URL_API_MBR600G01 = '/api/v1.0/user/core/webcontents/aftrequestprocess';

const URL_API_MTA100G01 = '/api/v1.0/login/mainte';
const URL_API_MTO100G01 = '/api/v1.0/user/mainte/information'
const URL_API_MTO200P01 = '/api/v1.0/mainte/managers/add';
const URL_API_MTO210G01 = '/api/v1.0/user/mainte/managers/:userId';
const URL_API_MTO210P01 = '/api/v1.0/user/mainte/managers/:userId';
const URL_API_MTO220P01 = '/api/v1.0/user/mainte/managers/searchconditions';
const URL_API_MTO220P02 = '/api/v1.0/user/mainte/managers/:userId/delete';
const URL_API_MTM100G01 = '/api/v1.0/user/mainte/customers/:customerId';
const URL_API_MTR100G01 = '/api/v1.0/user/mainte/requestdetails/searchconditions';
const URL_API_MTR100P01 = '/api/v1.0/user/mainte/requestdetails';
const URL_API_MTR200G01 = '/api/v1.0/user/mainte/requestdetails/:requestNo';
const URL_API_MTR200G02 = '/api/v1.0/user/mainte/fileinformation/:fileId';
const URL_API_MTR200P01 = '/api/v1.0/user/mainte/requestdetails/:requestNo/latestprogressclass';
const URL_API_MTR200P02 = '/api/v1.0/user/mainte/comment/:requestNo';
const URL_API_MTR200P03 = '/api/v1.0/user/mainte/:requestNo/fileinformation/:fileId';
const URL_API_MTR200P04 = '/api/v1.0/user/mainte/:requestNo/fileinformation/:fileId/delete';
const URL_API_MTR200P05 = '/api/v1.0/user/mainte/verifyhistory/:requestNo/verifystatus';
const URL_API_MTQ100P01 = '/api/v1.0/user/mainte/inquiries';
const URL_API_MTQ200G01 = '/api/v1.0/user/mainte/inquiries/:inquiryNo';
const URL_API_MTR300P01 = '/api/v1.0/user/mainte/verifyhistory/:requestNo/verifyAppRequest';

/* URL その他 */
const URL_API_ERA100P01 = '/api/v1.0/all/app/verifyappreqest/add';
const URL_API_ERV100P01 = '/api/v1.0/all/verify/verifyappreqest/verifystatus';

const URL_HOMEPAGE_AOZORA = 'http://aozoralaw.com/';

/*
 *  凍結化
 */
Object.freeze({

});

import Utils from "./utils";
export default {

  CHAR_NULL,

  // 編集状態
  EDIT_STATUS_BEFORE_INPUT,
  EDIT_STATUS_INPUT,
  EDIT_STATUS_CONFIRM,
  EDIT_STATUS_REQUEST,
  // システム 
  SYS_ID_TOUKI,
  // 役員入力
  INPUT_TYP_APPOINT,
  INPUT_TYP_RESIGN,
  INPUT_TYP_ADDRESS,
  // 役員変更
  CHANGE_OFFICER_KBN_OTHERS,
  // 資格
  OFFICER_KBN_DAIHYO,
  // URL API
  URL_API_PSS400G01,
  URL_API_PSS400P01,
  URL_API_MBA100G01,
  URL_API_MBA200P01,
  URL_API_MBC100G01,
  URL_API_MBC100P01,
  getUrlApiMBC110G01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MBC110G01.replace(":customerId", customerId);
  },
  getUrlApiMBC110P01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MBC110P01.replace(":customerId", customerId);
  },
  URL_API_MBC120G01,
  getUrlApiMBC120P01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MBC120P01.replace(":customerId", customerId);
  },
  getUrlApiMBC200P01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MBC200P01.replace(":customerId", customerId);
  },
  getUrlApiMBC210P01: function(onetimeurl) {
    if (Utils.isNullOrEmptyOrUunDef(onetimeurl)) {
      onetimeurl = CHAR_NULL;
    }
    return URL_API_MBC210P01.replace(":onetimeurl", onetimeurl);
  },
  getUrlApiMBR100G01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MBR100G01.replace(":customerId", customerId);
  },
  URL_API_MBR400G01,
  getUrlApiMBR500G01: function(customerId, requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    let url = "";
    url = URL_API_MBR500G01.replace(":customerId", customerId);
    url = url.replace(":requestNo", requestNo);
    return url;
  },
  getUrlApiMBR500G02: function(fileId) {
    if (Utils.isNullOrEmptyOrUunDef(fileId)) {
      fileId = CHAR_NULL;
    }
    return URL_API_MBR500G02.replace(":fileId", fileId);
  },
  getUrlApiMBR500P01: function(requestNo, fileId) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(fileId)) {
      fileId = CHAR_NULL;
    }
    let url = "";
    url = URL_API_MBR500P01.replace(":requestNo", requestNo);
    url = url.replace(":fileId", fileId);
    return url;
  },
  getUrlApiMBR500P02: function(requestNo, fileId) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(fileId)) {
      fileId = CHAR_NULL;
    }
    let url = "";
    url = URL_API_MBR500P02.replace(":requestNo", requestNo);
    url = url.replace(":fileId", fileId);
    return url;
  },
  URL_API_MBR500P03,
  getUrlApiMBR510P01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MBR510P01.replace(":customerId", customerId);
  },
  getUrlApiMBR510P02: function(requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    return URL_API_MBR510P02.replace(":requestNo", requestNo);
  },
  URL_API_MBR600G01,
  URL_API_MTA100G01,
  URL_API_MTO100G01,
  URL_API_MTO200P01,
  getUrlApiMTO210G01: function(userId) {
    if (Utils.isNullOrEmptyOrUunDef(userId)) {
      userId = CHAR_NULL;
    }
    return URL_API_MTO210G01.replace(":userId", userId);
  },
  getUrlApiMTO210P01: function(userId) {
    if (Utils.isNullOrEmptyOrUunDef(userId)) {
      userId = CHAR_NULL;
    }
    return URL_API_MTO210P01.replace(":userId", userId);
  },
  URL_API_MTO220P01,
  getUrlApiMTM100G01: function(customerId) {
    if (Utils.isNullOrEmptyOrUunDef(customerId)) {
      customerId = CHAR_NULL;
    }
    return URL_API_MTM100G01.replace(":customerId", customerId);
  },
  getUrlApiMTO220P02: function(userId) {
    if (Utils.isNullOrEmptyOrUunDef(userId)) {
      userId = CHAR_NULL;
    }
    return URL_API_MTO220P02.replace(":userId", userId);
  },
  URL_API_MTR100G01,
  URL_API_MTR100P01,
  getUrlApiMTR200G01: function(requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    return URL_API_MTR200G01.replace(":requestNo", requestNo);
  },
  getUrlApiMTR200G02: function(fileId) {
    if (Utils.isNullOrEmptyOrUunDef(fileId)) {
      fileId = CHAR_NULL;
    }
    return URL_API_MTR200G02.replace(":fileId", fileId);
  },
  getUrlApiMTR200P01: function(requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    return URL_API_MTR200P01.replace(":requestNo", requestNo);
  },

  getUrlApiMTR200P02: function(requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    return URL_API_MTR200P02.replace(":requestNo", requestNo);
  },
  getUrlApiMTR200P03: function(requestNo, fileId) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(fileId)) {
      fileId = CHAR_NULL;
    }
    let url = "";
    url = URL_API_MTR200P03.replace(":requestNo", requestNo);
    url = url.replace(":fileId", fileId);
    return url;
  },
  getUrlApiMTR200P04: function(requestNo, fileId) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(fileId)) {
      fileId = CHAR_NULL;
    }
    let url = "";
    url = URL_API_MTR200P04.replace(":requestNo", requestNo);
    url = url.replace(":fileId", fileId);
    return url;
  },
  getUrlApiMTR200P05: function(requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    return URL_API_MTR200P05.replace(":requestNo", requestNo);
  },
  URL_API_MTQ100P01,
  getUrlApiMTQ200G01: function(inquiryNo) {
    if (Utils.isNullOrEmptyOrUunDef(inquiryNo)) {
      inquiryNo = CHAR_NULL;
    }
    return URL_API_MTQ200G01.replace(":inquiryNo", inquiryNo);
  },
  getUrlApiURL_API_MTR300P01: function(requestNo) {
    if (Utils.isNullOrEmptyOrUunDef(requestNo)) {
      requestNo = CHAR_NULL;
    }
    return URL_API_MTR300P01.replace(":requestNo", requestNo);
  },

  /* URL その他 */
  URL_API_ERA100P01,
  URL_API_ERV100P01,
  URL_HOMEPAGE_AOZORA,

  
};
